
  export default {
    name: 'BreadCrumb',
      props: {
          title: {
              type: String,
              default: null,
          },
          traslate: {
            type: Boolean,
            default: false
          }
      },
      computed: {
          crumbs() {
              const fullPath = this.$route.fullPath
              const params = fullPath.startsWith('/')
                  ? fullPath.substring(1).split('/')
                  : fullPath.split('/')
              const crumbs = []
              let path = ''
              params.forEach((param, index) => {
                  path = `${path}/${param}`
                  const match = this.$router.match(path)
                  if (match.name !== null) {
                      crumbs.push({
                          title: param,
                          ...match,
                      })
                  }
              })
              return crumbs
          },
      },
  }
